import React from 'react'
import styled from 'styled-components'

function LawLessons() {
    return (
        <Container>
            <h4>نصائح قانونية</h4>
            <Content>
            <Wrap href="https://instagram.fkwi5-2.fna.fbcdn.net/v/t50.16885-16/86255808_482489415750322_577383044429148819_n.mp4?efg=eyJ2ZW5jb2RlX3RhZyI6InZ0c192b2RfdXJsZ2VuLjEyODAuaWd0di5kZWZhdWx0IiwicWVfZ3JvdXBzIjoiW1wiaWdfd2ViX2RlbGl2ZXJ5X3Z0c19vdGZcIl0ifQ&_nc_ht=instagram.fkwi5-2.fna.fbcdn.net&_nc_cat=110&_nc_ohc=_lr3b5ux-Z4AX81_Yar&edm=AABBvjUBAAAA&vs=17884021438487163_563189437&_nc_vs=HBksFQAYJEdNQW9KQVd5MGp0UzByWUJBSk55aU43UlJnTUlidlZCQUFBRhUAAsgBABUAGCRHTnhsSVFWX1loVkhDeVlKQUxuY3ltQ0Q4WU1NYnZWQkFBQUYVAgLIAQAoABgAGwGIB3VzZV9vaWwBMRUAACb2ntaU%2FtrEPxUCKAJDMywXQFmbtkWhysEYEmRhc2hfYmFzZWxpbmVfMV92MREAdewHAA%3D%3D&_nc_rid=820ad96ae7&ccb=7-4&oe=619C0843&oh=e63e4c49f998cef726928360594aebbc&_nc_sid=83d603">
            <img src="/images/test150.png" alt="المحامي محمد المظفر يقدم نصيحة قانونية عند التعامل مع المقاولين" />
            </Wrap>

            <Wrap href="https://instagram.fkwi5-2.fna.fbcdn.net/v/t50.16885-16/84404788_213745729665049_3070143238053438782_n.mp4?efg=eyJ2ZW5jb2RlX3RhZyI6InZ0c192b2RfdXJsZ2VuLjYyNi5pZ3R2LmRlZmF1bHQiLCJxZV9ncm91cHMiOiJbXCJpZ193ZWJfZGVsaXZlcnlfdnRzX290ZlwiXSJ9&_nc_ht=instagram.fkwi5-2.fna.fbcdn.net&_nc_cat=101&_nc_ohc=2bZ-qvSoeFEAX_EScpE&edm=AABBvjUBAAAA&vs=18101964223115603_1686378480&_nc_vs=HBksFQAYJEdEVHFCd1VaX0VtT1pzSUFBRDRsdmprQ1Y1c3FidlZCQUFBRhUAAsgBABUAGCRHTjdvRGdYWFo4b0wxcWNBQU5uYWJ0N2d2elIwYnZWQkFBQUYVAgLIAQAoABgAGwGIB3VzZV9vaWwBMRUAACam2KTy%2FuinQBUCKAJDMywXQFyEOVgQYk4YEmRhc2hfYmFzZWxpbmVfMV92MREAdewHAA%3D%3D&_nc_rid=f47284b480&ccb=7-4&oe=619BE647&oh=b644f1491a296ed4dcd76eafe372f0de&_nc_sid=83d603">
            <img src="/images/newLaw2.png" alt="المحامي محمد المظفر يقدم نصيحة قانونية عن العنف الاسري" />
            </Wrap>

            <Wrap href="https://firebasestorage.googleapis.com/v0/b/barcode-2929d.appspot.com/o/84126721_777374159414241_776576978226179986_n.mp4?alt=media&token=471dc08f-6fe3-4d87-9096-0041c0e4c48f">
            <img src="/images/newLaw3.png" alt="المحامي محمد المظفر يتحدث عن السلف" />
            </Wrap>

            <Wrap href="https://firebasestorage.googleapis.com/v0/b/barcode-2929d.appspot.com/o/travel.mp4?alt=media&token=e7581f91-9ca5-471c-9d56-e512f74749c1">
            <img src="/images/newLaw4.png" alt="المحامي محمد المظفر و كيفية رفع منع السفر" />
            </Wrap>

            <Wrap href="https://instagram.fkwi5-2.fna.fbcdn.net/v/t50.16885-16/72637725_122000265516389_638050114652844940_n.mp4?efg=eyJ2ZW5jb2RlX3RhZyI6InZ0c192b2RfdXJsZ2VuLjg0OC5pZ3R2LmRlZmF1bHQiLCJxZV9ncm91cHMiOiJbXCJpZ193ZWJfZGVsaXZlcnlfdnRzX290ZlwiXSJ9&_nc_ht=instagram.fkwi5-2.fna.fbcdn.net&_nc_cat=105&_nc_ohc=cg4H7HJswx0AX83L-vS&edm=AABBvjUBAAAA&vs=18104200264032146_1497482084&_nc_vs=HBksFQAYJEdCMWRWQVJsRlgxbTlXNEFBSXl6eF9BeXo5b0lidlZCQUFBRhUAAsgBABUAGCRHSWdFVkFRMkp0S1h4cnNCQUFqRUxXelRoWEJ4YnZWQkFBQUYVAgLIAQAoABgAGwGIB3VzZV9vaWwBMRUAACak7%2FTHkuuoQBUCKAJDMywXQFL7tkWhysEYEmRhc2hfYmFzZWxpbmVfMV92MREAdewHAA%3D%3D&_nc_rid=3b4b86d83a&ccb=7-4&oe=619BC115&oh=0f39be0f26815e04c1ed455139e330c2&_nc_sid=83d603">
            <img src="/images/newLaw5.png" alt="المحامي محمد المظفر كيفية رفع قضية ادارية" />
            </Wrap>

            <Wrap href="https://instagram.fkwi5-2.fna.fbcdn.net/v/t50.16885-16/84201318_2283767815257091_307377867978925250_n.mp4?efg=eyJ2ZW5jb2RlX3RhZyI6InZ0c192b2RfdXJsZ2VuLjYyNi5pZ3R2LmRlZmF1bHQiLCJxZV9ncm91cHMiOiJbXCJpZ193ZWJfZGVsaXZlcnlfdnRzX290ZlwiXSJ9&_nc_ht=instagram.fkwi5-2.fna.fbcdn.net&_nc_cat=107&_nc_ohc=ni1SBaIxOrYAX_yLEt-&edm=AABBvjUBAAAA&vs=17884362886485988_430958462&_nc_vs=HBksFQAYJEdHYlBCQVVEdkdBaEV4MElBTUprczlpS0JrUUVidlZCQUFBRhUAAsgBABUAGCRHTHlYOXdUVEU2ZUVxMjhBQUpib0tUdEIyWWtxYnZWQkFBQUYVAgLIAQAoABgAGwGIB3VzZV9vaWwBMRUAACbI1o2T9u7EPxUCKAJDMywXQGI5mZmZmZoYEmRhc2hfYmFzZWxpbmVfMV92MREAdewHAA%3D%3D&_nc_rid=3dfbae4579&ccb=7-4&oe=619BC420&oh=97ccfc726faa40841ab38f37245bbcad&_nc_sid=83d603">
            <img src="/images/newLaw6.png"  alt="المحامي محمد المظفر و نظر القانون للاشاعة"/>
            </Wrap>

            <Wrap href="https://instagram.fkwi5-2.fna.fbcdn.net/v/t50.16885-16/10000000_134317201424150_6220910911532195205_n.mp4?efg=eyJ2ZW5jb2RlX3RhZyI6InZ0c192b2RfdXJsZ2VuLjEyODAuaWd0di5kZWZhdWx0IiwicWVfZ3JvdXBzIjoiW1wiaWdfd2ViX2RlbGl2ZXJ5X3Z0c19vdGZcIl0ifQ&_nc_ht=instagram.fkwi5-2.fna.fbcdn.net&_nc_cat=102&_nc_ohc=i1Zj92lyolIAX8DVsgZ&edm=AABBvjUBAAAA&vs=17867295214636422_2436488902&_nc_vs=HBksFQAYJEdJQ1dtQUFXLXhNcEtYb0FBSVZkT3FXREhWVldidlZCQUFBRhUAAsgBABUAGCRHUGtVUHdWcnpYcEFTaDhKQUI3MUxTdGdJQ05LYnZWQkFBQUYVAgLIAQAoABgAGwGIB3VzZV9vaWwBMRUAACaM8rq8rI29PxUCKAJDMywXQGAIgxJul40YEmRhc2hfYmFzZWxpbmVfMV92MREAdewHAA%3D%3D&_nc_rid=bcfbf05b78&ccb=7-4&oe=619C0A43&oh=647c3cf43a2bde33d9e2daebc87331f9&_nc_sid=83d603">
            <img src="/images/newLaw7.png" alt="المحامي محمد المظفر نادي مو صحي" />
            </Wrap>

            <Wrap href="https://firebasestorage.googleapis.com/v0/b/barcode-2929d.appspot.com/o/women.mp4?alt=media&token=7a39a3a4-3734-4f26-885c-ca30c601ee40"> 
            <img src="/images/newLaw8.png" alt="المحامي محمد المظفر و علاوة المرأة"/>
            </Wrap>
            
            </Content>

           
            
        </Container>
    )
}

export default LawLessons

const Container = styled.div`
margin-top: 60px;
margin-bottom: 50px;


`

const Content = styled.div`
display: grid;
grid-gap: 25px;
grid-template-columns: repeat(4, minmax(0, 1fr));
@media only screen and (min-width: 480px) and (max-width: 768px) {
   
    grid-template-columns: repeat(2, minmax(0, 1fr));
    
 
  }
@media only screen and (max-width: 479px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    
  }


`

const Wrap = styled.a`
    border-radius: 10px;
    cursor: pointer;
    overflow: hidden;
    border: 3px solid rgba(249, 249, 249, 0.1);
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
    
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
        transform: scale(1.05);
        border-color: rgba(249, 249, 249, 0.8);
    }
`
